import { render, staticRenderFns } from "./PaperEdit.vue?vue&type=template&id=ebfefc36&scoped=true&"
import script from "./PaperEdit.vue?vue&type=script&lang=js&"
export * from "./PaperEdit.vue?vue&type=script&lang=js&"
import style0 from "./PaperEdit.vue?vue&type=style&index=0&id=ebfefc36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfefc36",
  null
  
)

export default component.exports